import dayjsTZ from "../../../../utils/dayjs";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useAuth } from "../../../../authentication/authHelpers";
import "./HolidayWidget.scss";
import { useMediaQuery } from "react-responsive";
import MobileHtmlTabel from "../../../../utils/MobileComponents/MobileHtmlTabel";

function HolidayWidget() {
  const { employee } = useAuth();

  const { programFields } = useSelector((state) => state.programFields);
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [holidays, setHolidays] = useState([]);

  const retrieveHolidays = () => {
    const getFestat = programFields.find(
      (field) => field.fieldId === "a3a610f9-5a60-40ec-8a1d-d94ffbb10054"
    );
    let temp = getFestat?.fieldOptions?.map((option) => ({
      ...option,
      date: dayjsTZ(option?.date, "DD/MM/YYYY"),
    }));
    setHolidays(temp || []);
  };

  useEffect(() => {
    if (!!programFields) {
      retrieveHolidays();
    }
  }, [programFields]);

  const isMobileView = useMediaQuery({
    query: "(min-width: 460px)",
  });

  return (
    <div className={`holiday-widget-comp ${isDarkMode ? "dark" : ""}`}>
      {isMobileView ? (
        <>
          <div className="holiday-widget-header">
            <div className="item-header" style={{ width: "20%" }}>
              Dita e javës
            </div>
            <div className="item-header" style={{ width: "20%" }}>
              Data Zyrtare
            </div>
            <div className="item-header" style={{ width: "40%" }}>
              Titulli
            </div>
            <div className="item-header" style={{ width: "20%" }}>
              Data efektive
            </div>
          </div>
          <div className="holiday-calendar-content">
            {holidays
              ?.filter(
                (el) =>
                  dayjsTZ(el?.effectiveDate).format("MM/DD/YYYY") >=
                  dayjsTZ().format("MM/DD/YYYY")
              )
              ?.filter((a) => !a?.users?.includes(employee?.employeeId))
              ?.sort((a, b) => a?.effectiveDate - b?.effectiveDate)
              .map?.((el, key) => (
                <div className="content-holiday" key={key}>
                  <div style={{ width: "20%" }} className="content-item">
                    <div
                      className="item-day"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        height: 24,
                        background: el?.color,
                      }}
                    >
                      {el?.dayOfWeek}
                    </div>
                  </div>
                  <div style={{ width: "20%" }} className="content-item">
                    {" "}
                    {dayjsTZ(el?.date).format("DD/MM/YYYY")}
                  </div>
                  <div className="content-item" style={{ width: "40%" }}>
                    {el?.title}
                  </div>
                  <div className="content-item" style={{ width: "20%" }}>
                    {dayjsTZ(el?.effectiveDate).format("DD/MM/YYYY")}{" "}
                  </div>
                </div>
              ))}
          </div>
        </>
      ) : (
        <MobileHtmlTabel
          header={["Dita e javës", "Data Zyrtare", " Titulli", "Data efektive"]}
          tableData={holidays
            ?.filter(
              (el) =>
                dayjsTZ(el?.effectiveDate).format("MM/DD/YYYY") >=
                dayjsTZ().format("MM/DD/YYYY")
            )
            ?.filter((a) => !a?.users?.includes(employee?.employeeId))
            ?.sort((a, b) => a?.effectiveDate - b?.effectiveDate)
            .map?.((el) => {
              return {
                dayOfWeek: el?.dayOfWeek,
                officialDay: dayjsTZ(el?.date).format("DD/MM/YYYY"),
                title: el?.title,
                effectiveDate: dayjsTZ(el?.effectiveDate).format("DD/MM/YYYY"),
              };
            })}
        />
      )}
    </div>
  );
}

export default HolidayWidget;
